<template>
  <section class="card-slider">
    <h2 class="card-slider__title">
      {{ title }}
    </h2>

    <FlickitySlider :white="white">
      <component
        v-for="(card, i) of cards"
        :class="['card-slider__card', { pdf: cardType.includes('PDF') }]"
        :key="card.title"
        :is="cardComponents[cardType]"
        v-bind="card"
        :cardType="generalCardLabel"
        clickable
        @onClick="$emit('onCardClick', i)"
      />
    </FlickitySlider>
  </section>
</template>

<script setup>
import ArchiveCard from "../general/ArchiveCard.vue";
import PDFCard from "../general/PDFCard.vue";
import ImageCard from "../general/ImageCard.vue";
import FlickitySlider from "../general/FlickitySlider.vue";

defineProps({
  cardType: String,
  title: String,
  generalCardLabel: String,
  cards: {
    type: Array,
    default: () => [],
  },
  white: Boolean,
});

// TODO: New component for interview slider, that gets interview content from correct place

const cardComponents = {
  ArchiveCard,
  PDFCard,
  ImageCard,
};
</script>

<style lang="scss" scoped>
.card-slider {
  background-color: var(--page-color, var(--white-100));
  padding: 7vh var(--page-padding-h);
  position: relative;
  // width: var(--vw-no-scrollbar, 100vw);
  overflow: hidden;

  :not(.download-multimedia) & {
    color: var(--white-100);
  }

  .download-multimedia & {
    color: var(--black-100);
  }

  &__title {
    @include title-m;

    margin-bottom: 1.75rem;

    .download-multimedia & {
      @include h-h-2;

      margin-bottom: 1.25rem;
    }

    .mobile & {
      margin-bottom: 3rem;
    }
  }

  &__card {
    margin: 0 0.5rem;

    &.pdf {
      // TODO: this doesnt work because overflow hidden on card

      &:last-child {
        margin: 0 0.5rem 0 1rem;
      }

      &:nth-last-child(2) {
        margin: 0 1rem;
      }

      &:nth-last-child(3) {
        margin: 0 1rem 0 0.5rem;
      }

      &:last-child,
      &:nth-last-child(2) {
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: -1rem;
          height: 100%;
          border-left: 1px solid var(--scala-grigi-gray-2);
        }
      }
    }
  }
}
</style>
